import gql from 'graphql-tag'

export default gql`
	query LocalQuery_getLocale {
		getLocale @client
	}
`
